import type { ReactNode } from "react";

/** Same shape everywhere: a line that says what is missing and, usually, the way to fix it. */
export function EmptyState({
  title,
  description,
  action,
  testId,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  testId?: string;
}) {
  return (
    <div
      className="flex flex-col items-center gap-2 rounded-lg border border-dashed px-6 py-12 text-center"
      data-testid={testId}
    >
      <p className="font-medium">{title}</p>
      {description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
